import * as angular from "angular";
import { Team } from "../models/team.model";

export class TeamService {
    private readonly v2Root: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.v2Root = "/v2/team";
    }

    create(team: Team): Promise<object> {
        return this.$http.post(this.v2Root + "/create", team);
    }

    update(team: Team): Promise<object> {
        return this.$http.post(this.v2Root + "/update/" + team.tid, team);
    }

    all(): Promise<object> {
        return this.$http.get(this.v2Root + "/all");
    }

    filtered(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/all", {
            params: data,
            cancellable: true,
        });
    }

    details(teamId: string | number): Promise<object> {
        return this.$http.get(this.v2Root + "/details/" + teamId);
    }

    group(teamId: string | number): Promise<object> {
        return this.$http.get(this.v2Root + "/group/" + teamId);
    }

    addToTeam(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/add_users", data);
    }

    survey(teamId: string | number): Promise<object> {
        return this.$http.get(this.v2Root + "/survey/" + teamId);
    }

    talking_point(teamId: string | number): Promise<object> {
        return this.$http.get(this.v2Root + "/talking_point/" + teamId);
    }

    info(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/info", data);
    }

    remove_user(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/remove_user", data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.v2Root + "/" + data.id, { params: data });
    }

    bulkDelete(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/bulk_delete", data);
    }
}

angular.module("vcServices").service("TeamService", TeamService);
